import { Action, Dispatch } from 'redux';
import { ReduxAction } from '../../core';

import { HealAPI } from '../../../healApi';
import { OnSite } from './types';
import { toast } from '../../message/actions';

export class OnSiteActions {
  public static SET_IS_FETCHING_ONSITE_EVENTS = `ONSITES_SET_IS_FETCHING_ONSITE_EVENTS`;
  public static SET_ONSITE_EVENTS = `ONSITES_SET_ONSITE_EVENTS`;
  public static SET_ONSITE_EVENTS_ERROR = `ONSITES_SET_ONSITE_EVENTS_ERROR`;

  public static CREATE_ONSITE_EVENT = `ONSITES_CREATE_ONSITE_EVENT`;
  public static DELETE_ONSITE_EVENT = `ONSITES_DELETE_ONSITE_EVENT`;
  public static UPDATE_ONSITE_EVENT = `ONSITES_UPDATE_ONSITE_EVENT`;
  public static ONSITE_EMAIL_SENT = `ONSITES_ONSITE_EMAIL_SENT`;
}

export function setOnSitesEventsFetching(value: boolean): ReduxAction<boolean> {
  return {
    type: OnSiteActions.SET_IS_FETCHING_ONSITE_EVENTS,
    data: value,
  };
}

export function setOnSiteEvents(value: OnSite[]): ReduxAction<OnSite[]> {
  return {
    type: OnSiteActions.SET_ONSITE_EVENTS,
    data: value,
  };
}

export function setOnSiteEventsError(value: string): ReduxAction<string> {
  return {
    type: OnSiteActions.SET_ONSITE_EVENTS_ERROR,
    data: value,
  };
}

export function updateOnSiteEvent(onsite: OnSite): ReduxAction<OnSite> {
  return {
    type: OnSiteActions.UPDATE_ONSITE_EVENT,
    data: onsite,
  };
}

export function deleteOnSiteEvent(onSiteId: string) {
  return (dispatch: Dispatch<Action>) => {
    return HealAPI.deleteOnSiteEvent(onSiteId)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: OnSiteActions.DELETE_ONSITE_EVENT, data: onSiteId });
          dispatch(
            toast({
              type: 'success',
              title: 'Success',
              content: 'On Site event deleted successfully',
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          toast({
            type: 'success',
            title: 'Success',
            content: error || 'Could not connect to server',
          })
        );
      });
  };
}

export function sendOnsiteEmail(onSiteId: string, isPromo: boolean, isCashPay: boolean) {
  return (dispatch: Dispatch<Action>) => {
    HealAPI.sendOnSiteEmail(onSiteId, isPromo, isCashPay)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: OnSiteActions.ONSITE_EMAIL_SENT,
            data: { onSiteId: onSiteId, isPromo: isPromo, isCashPay: isCashPay },
          });
          dispatch(
            toast({
              type: 'success',
              title: 'Success',
              content: 'Email sent successfully to ' + response.data.email,
            })
          );
        } else {
          dispatch(
            toast({
              type: 'error',
              title: 'Error',
              content: "Email was not sent successfully. Couldn't connect to server.",
            })
          );
        }
      })
      .catch(() => {
        dispatch(
          toast({
            type: 'error',
            title: 'Error',
            content: "Email was not sent successfully. Couldn't connect to server.",
          })
        );
      });
  };
}
